/* cookie */
/*--------------------------------------------------------------------------------*/
export interface CookieOption {
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
    sameSite?: 'Lax' | 'Strict' | 'None';
}
/*--------------------------------------------------------------------------------*/
export const setItem = (key: string, val: string, opt: CookieOption = {}): void => {
    const { expires, path = '/', domain, secure = true, sameSite = 'Lax' } = opt;
    let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    if (expires) {
        const expDate = expires instanceof Date
            ? expires : new Date(Date.now() + expires * 1000);
        cookie += `;expires=${expDate.toUTCString()}`;
    }
    cookie += `;path=${path}`;
    if (domain) cookie += `;domain=${domain}`;
    if (secure) cookie += `;secure`;
    cookie += `;samesite=${sameSite}`;
    document.cookie = cookie;
};
/*--------------------------------------------------------------------------------*/
export const getItem = (key: string): string | null => {
    const name = encodeURIComponent(key) + "=";
    const decode = decodeURIComponent(document.cookie);
    const ca = decode.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
};
/*--------------------------------------------------------------------------------*/
export const removeItem = (key: string, path: string = '/', domain?: string): void => {
    let deleteString = `${encodeURIComponent(key)}=;`;
    deleteString += `expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    deleteString += `path=${path}`;
    if (domain) deleteString += `;domain=${domain}`;
    document.cookie = deleteString;
};
/*--------------------------------------------------------------------------------*/
export const clear = (): void => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
        removeItem(name);
    }
};
/*--------------------------------------------------------------------------------*/
